import React, { useState } from "react";
import modalImage from "../../assets/img/modalImage.jpeg";
// import modalImage from "../../assets/img/full-shot-couple-talking-real-estate-agent 1 (1).png";

import SelectVisitTime from "./SelectVisitTime";
import AppointmentRequest from "./AppointmentRequest";

const VisitModal = ({ isOpen, onClose, selectedItems, selectedISOCode }) => {
  const [isVisitSelected, setIsVisitSelected] = useState(true);
  const [requestData, setRequestData] = useState([]);
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 p-3 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-[30px] shadow-lg w-[730px]"
      >
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-4">
            <div className="w-full h-full md:aspect-[0.666] aspect-[2]">
              <img
                src={modalImage}
                alt=""
                className="w-full h-full object-cover md:rounded-se-none md:rounded-s-[20px] rounded-t-[20px]"
              />
            </div>
          </div>

          <div className="col-span-12 md:col-span-8">
            <div className="overflow-y-scroll md:p-5 p-3 h-[400px]">
              {isVisitSelected ? (
                <SelectVisitTime
                  setIsVisitSelected={setIsVisitSelected}
                  setRequestData={setRequestData}
                  selectedItems={selectedItems}
                  selectedISOCode={selectedISOCode}
                />
              ) : (
                <AppointmentRequest
                  requestData={requestData}
                  onClose={onClose}
                />
              )}
              {/* <SelectVisitTime /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitModal;
